export class RedBloodCellColor {
    static NORMAL = new RedBloodCellColor({ type: 'Normochromic', name: 'Normal' });
    static PALE = new RedBloodCellColor({ type: 'Hypochromic', name: 'Pale' });
    static DARK = new RedBloodCellColor({ type: 'Hyperchromic', name: 'Dark' });
    static NOT_APPLICABLE = new RedBloodCellColor({ type: 'N/A', name: 'N/A' });

    type: string;
    name: string;

    constructor(redBloodCellColor?: RedBloodCellColor) {
        // This handles copying the simple properties
        if (!redBloodCellColor) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(redBloodCellColor).forEach(key => {
            this[key] = redBloodCellColor[key];
        });
    }
}
